export const disabledButtonCss = {
  opacity: 0.4,
  zIndex: 1,
  cursor: 'default',
  '&:hover:not([disabled])': {
    backgroundColor: 'unset',
  }
};
